// Does a wa.me link actually open WhatsApp on this device?
//
// On a phone it does, and it works beautifully. On a laptop it opens WhatsApp
// Web, which only works if the visitor has already linked their phone, so
// most desktop visitors hit a dead end. That is the whole reason the desktop
// "Chat on WhatsApp" button opens a dialog (Open WhatsApp, or leave a number).
//
// When the signals disagree, answer "phone". Showing a mobile user a form
// that asks for the number they are holding, while WhatsApp is one tap away,
// is the worse mistake of the two.
export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false

  // Client hints are the one signal the browser declares rather than us
  // sniffing a string. Chrome and Edge set it; trust a true.
  if (navigator.userAgentData && navigator.userAgentData.mobile === true) return true

  const ua = navigator.userAgent || ''
  if (/Android|iPhone|iPod|iPad|Windows Phone|IEMobile|BlackBerry|BB10|webOS|Opera Mini|Mobi/i.test(ua)) return true

  // iPadOS 13+ claims to be a Mac. A real Mac has no touch screen.
  if (/Macintosh/i.test(ua) && (navigator.maxTouchPoints || 0) > 1) return true

  // Last resort for a phone we have never heard of: no mouse, no hover, and
  // a screen small enough that it cannot be a touchscreen laptop.
  try {
    const noMouse = window.matchMedia('(hover: none) and (pointer: coarse)').matches
    const shortEdge = Math.min(window.screen.width || 0, window.screen.height || 0)
    return noMouse && shortEdge > 0 && shortEdge <= 820
  } catch (e) {
    return false
  }
}
